import React, { useEffect, useState } from "react";
import { Upload } from "antd";
import { useField } from "formik";
import "./AntFileUpload.css";
import imgFileUpload from "../../images/icons/upload.png";
import api from "../../api/api";
import apiUtil from "../../api/apiUtil";
import getToken from "../../pages/getToken";

const AntFileUpload = (props) => {
  const [field, meta, helpers] = useField(props);
  const [fileObjects, setFileObjects] = useState([]);
  const hasError = meta.touched && meta.error;
  const { value } = meta;

  const [imageSize, setImageSize] = useState([]);
  const getImageSize = () => {
    api
      .get("Admin/GetSettingDetailByAdmin", { Name: "LogoSize" }, getToken())
      .then((result) =>
        apiUtil.parseResult(
          result,
          (response) => {
            console.log(response.data.data);
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              setImageSize(response.data.data);
            } else {
              alert(response.data.message);
            }
          },
          (error) => {
            setImageSize([]);
            console.log(error);
          }
        )
      );
  };

  useEffect(() => {
    getImageSize();
    if (value == null || value === "" || value === "-") {
      helpers.setValue(null);
      setFileObjects([]);
    } else {
      const fileArray = value.map((file) => ({
        uid: file.uid,
        name: file.name,
        url: file.url || URL.createObjectURL(file.originFileObj),
        status: "done",
      }));
      setFileObjects(fileArray);
    }
  }, [value]);

  const handleChange = ({ fileList }) => {
    const maxSizeInBytes = imageSize.valueInInt? (imageSize.valueInInt * 1024 * 1024) : (5 * 1024 * 1024);
    const validFiles = fileList.filter((file) => {
      if (file.size > maxSizeInBytes) {
        alert(`Image size exceeds ${imageSize.valueInInt ? imageSize.valueInInt : 5} MB limit. Please choose a smaller one!`);
        return false;
      }
      return true;
    });

    const updatedFileList = validFiles.map(async (file) => {
      if (!file.url && file.originFileObj) {
        const base64 = await getBase64(file.originFileObj);
        return {
          ...file,
          url: base64,
        };
      }
      return file;
    });

    Promise.all(updatedFileList).then((updatedFiles) => {
      setFileObjects(updatedFiles);
      helpers.setValue(updatedFiles);
      if (props.onChange) {
        props.onChange({ fileList: updatedFiles });
      }
    });
  };

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  return (
    <div id="AntiFileUpload" className={`input_wrapper	${props.customclass} `}>
      {props.label && (
        <label className="label" htmlFor={props.name}>
          {props.label}
        </label>
      )}
      <Upload
        name={props.name}
        accept={props.accept}
        listType="picture-card"
        fileList={fileObjects}
        onChange={handleChange}
        onRemove={props.handleRemove}
        showUploadList={{ showPreviewIcon: false }}
        multiple={props.multiple}
        customRequest={({ file, onSuccess, onError }) => {
          if (file.size > props.maxSizeInByte) {
            setTimeout(() => {
              onError(new Error("Large size"), "Large size");
            }, 0);
          } else {
            setTimeout(() => {
              onSuccess("Success");
            }, 1000);
          }
        }}
        disabled={props.disabled}
      >
        {!props.disabled && (
          <div>
            {props.addIcon && (
              <img
                src={imgFileUpload}
                alt="fileUpload"
                className="imgFileUpload"
              />
            )}
            <p>{props.inputText}</p>
          </div>
        )}
      </Upload>
      {hasError ? (
        <div className="error__text">{props.customError || meta.error}</div>
      ) : null}
    </div>
  );
};

export default AntFileUpload;
